import axios, { AxiosResponse, AxiosError } from "axios";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const storedUserDetails = localStorage.getItem("userdetails");
const token = storedUserDetails ? JSON.parse(storedUserDetails).token.replace(/^"(.*)"$/, '$1') : null;

export const getWarehouses = (
  page_number: number,
  per_page_records: string | null,
  warehouse_name?: string,
  _successCallBack?: (response: any) => void,
  _errorCallBack?: (errMessage: any) => void,
) => {
  const userDetailsFromStorage = JSON.parse(localStorage.getItem("userdetails") || "null");
  const headers = {
    Authorization: `Bearer ${userDetailsFromStorage?.token}`,
  };

  const params: Record<string, any> = {
    per_page_records: per_page_records ?? "",
    page_number,
  };
  if ( warehouse_name) params.warehouse_name=  warehouse_name;

  axios
    .get(`${global.api_url}/api/warehouses`, { headers, params })
    .then((response: AxiosResponse) => {
      if (response.status === 200 || response.status === 201) {
        _successCallBack?.(response.data);
      } else {
        _errorCallBack?.(`Unexpected status code: ${response.status}`);
      }
    })
    .catch((error: AxiosError<any>) => {
      console.log("Error caught:", error);

      if (error.response) {
        const { status, data } = error.response;

        if (status === 400 || status === 404) {
          _errorCallBack?.(data);
        } else if (status === 401) {
          localStorage.clear();
        } else {
          _errorCallBack?.(`Error ${status}: ${data?.message || "Unknown error"}`);
        }
      } else {
        _errorCallBack?.("Network or server error");
        console.log(error)
      }
    });
};
export const getWarehouseCompanyMapping = (
  companies_id: any,
  page_number?: number,
  per_page_records?: number,
  _successCallBack?: (response: any) => void,
  _errorCallBack?: (errMessage: any) => void,
) => {
  const userDetailsFromStorage = JSON.parse(localStorage.getItem("userdetails") || "null");
  const headers = {
    Authorization: `Bearer ${userDetailsFromStorage?.token}`,
  };

  const params = new URLSearchParams({
    companies_id: companies_id.toString(),
  });
  if (page_number !== undefined) {
    params.append('page_number', page_number.toString());
  }
  if (per_page_records !== undefined) {
    params.append('per_page_records', per_page_records.toString());
  }

  axios
    .get(`${global.api_url}/api/warehouses_companies?${params.toString()}`, { headers })
    .then((response: AxiosResponse) => {
      if (response.status === 200 || response.status === 201) {
        _successCallBack?.(response.data);
      } else {
        _errorCallBack?.(`Unexpected status code: ${response.status}`);
      }
    })
    .catch((error: AxiosError<any>) => {
      console.log("Error caught:", error);

      if (error.response) {
        const { status, data } = error.response;

        if (status === 400 || status === 404) {
          _errorCallBack?.(data);
        } else if (status === 401) {
          localStorage.clear();
        } else {
          _errorCallBack?.(`Error ${status}: ${data?.message || "Unknown error"}`);
        }
      } else {
        _errorCallBack?.("Network or server error");
      }
    });
};
export const warehouseClientMapping = (
    clientsId: any,
    warehouseId: any,
    successCallBack: (message: string) => void,
    errorCallBack: (errorMessage: string) => void
  ) => {
    const userDetailsFromStorage = JSON.parse(localStorage.getItem("userdetails") || "null");
    const payload = {
      clients_id:clientsId,
      warehouses_id:warehouseId,
    };
    const headers = {
      Authorization: `Bearer ${userDetailsFromStorage.token}`,
    };
    axios.post(
      `${global.api_url}/api/client_warehouses`,
      payload,
      { headers }
    )
    .then((response: AxiosResponse) => {
      if (response.status === 201) {
        successCallBack(response.data.message);
      } 
      else if (response.status === 200) {
        successCallBack(response.data.message);
      }
    })
    .catch((error: any) => {
      if (error.response) {
        if (error.response.status === 400) {
          errorCallBack(error.response.data);
        } else if (error.response.status === 401) {
          localStorage.clear();
          toast.error("Login Expired.");
        }
      } 
      else if( error.response?.status === 404)
        {
          errorCallBack(error?.response?.data);
        }
      else {
        toast.error("Server Error");
      }
    });
  };
  export const addWarehouses = (name:any,contact_name:any,latitude:any,longitude:any,remarks:any,phone:any,email:any,
    _successCallBack: (response: any) => void,
    _errorCallBack: (errMessage: any) => void,
    ) => {
      const userDetailsFromStorage = JSON.parse(localStorage.getItem("userdetails") || "null");
      const headers = {
        Authorization: `Bearer ${userDetailsFromStorage.token}`, 
      };
      const payload = {
        name,
        contact_name,
        phone,
        email,
        latitude,
        longitude,
        remarks
      };
    axios
      .post(`${global.api_url}/api/warehouses`, payload, { headers })
      
      .then((response: AxiosResponse) => {
        if (response.status === 200 || response.status === 201) {
          _successCallBack(response.data);
        } else {
          _errorCallBack("Unexpected status code: " + response.status);
        }
      })
      .catch((error: AxiosError) => {
          console.log('Error caught:', error);
          if (error.response?.status === 400) {
            _errorCallBack(error.response.data);
          } else if (error.response?.status === 404) {
              console.log(error.response.data);
            _errorCallBack(error.response.data);
          }else if (error.response?.status === 401) {
            localStorage.clear();
          } 
        });
  };
  export const editWarehouses = (
    name:any,contact_name:any,latitude:any,longitude:any,remarks:any,phone,email:any,warehouses_id:any,
    _successCallBack: (response: any) => void,
    _errorCallBack: (errMessage: any) => void,
  ) => {
    const userDetailsFromStorage = JSON.parse(localStorage.getItem("userdetails") || "null");
    const headers = {
      Authorization: `Bearer ${userDetailsFromStorage.token}`, 
      'Content-Type': 'application/json',
    };
    const payload = {
      name,
        contact_name,
        phone,
        email,
        latitude,
        longitude,
        remarks
    
    };
    axios
      .put(`${global.api_url}/api/warehouses/${warehouses_id}`, payload, { headers })
      .then((response: AxiosResponse) => {
        if (response.status === 200) {
          _successCallBack(response.data); 
        }
        else if(response.status === 201) {
          _successCallBack(response.data);
        }
      })
      .catch((error: AxiosError) => {
        console.log('Error caught:', error);
        if (error.response?.status === 400) {
          _errorCallBack(error.response.data); 
        } 
        else if (error.response?.status === 404) {
          _errorCallBack(error.response.data);
        }else if  (error.response?.status === 401){
          localStorage.clear();
        }
        else{
          toast.error("Server Error");
        }
      });
  };
  export const deleteWarehouses = (
    warehouse_id: any,
    _successCallBack: (response: any) => void,
    _errorCallBack: (errMessage: any) => void
  ) => {
    const userDetailsFromStorage = JSON.parse(localStorage.getItem("userdetails") || "null");
    const headers = {
      Authorization: `Bearer ${userDetailsFromStorage.token}`
    };
  
    axios
      .delete(`${global.api_url}/api/warehouses/${warehouse_id}`, {
        headers: headers,

      })
      .then((response: AxiosResponse) => {
        if (response.status === 200) {
          _successCallBack(response.data);
        }
        else if (response.status === 200) {
          _successCallBack(response.data);
        } 
      })
      .catch((error: AxiosError) => {
        console.log('Error caught:', error);
        if (error.response?.status === 400) {
          _errorCallBack(error.response.data);
        } else if (error.response?.status === 401) {
          localStorage.clear();
          toast.error("Login Expired.");
        }  else if( error.response?.status === 404)
          {
            _errorCallBack(error?.response?.data);
          }
        else {
          toast.error("Server Error");
        }
      });
  };
    export const deleteWarehouseCompanyMapping = (
    id: any,
    _successCallBack: (response: any) => void,
    _errorCallBack: (errMessage: any) => void
  ) => {
    const userDetailsFromStorage = JSON.parse(localStorage.getItem("userdetails") || "null");
    const headers = {
      Authorization: `Bearer ${userDetailsFromStorage.token}`
    };
  
    axios
      .delete(`${global.api_url}/api/warehouses_companies/${id}`, {
        headers: headers,

      })
      .then((response: AxiosResponse) => {
        if (response.status === 200) {
          _successCallBack(response.data);
        }
        else if (response.status === 200) {
          _successCallBack(response.data);
        } 
      })
      .catch((error: AxiosError) => {
        console.log('Error caught:', error);
        if (error.response?.status === 400) {
          _errorCallBack(error.response.data);
        } else if (error.response?.status === 401) {
          localStorage.clear();
          toast.error("Login Expired.");
        }  else if( error.response?.status === 404)
          {
            _errorCallBack(error?.response?.data);
          }
        else {
          toast.error("Server Error");
        }
      });
  };
  
  export const getClients = (
    _successCallBack: (response: any) => void,
    _errorCallBack: (errMessage: any) => void,
  ) => {
    const userDetailsFromStorage = JSON.parse(localStorage.getItem("userdetails") || "null");
    const headers = {
      Authorization: `Bearer ${userDetailsFromStorage.token}`
    };
    axios
      .get(`${global.api_url}/api/clients_vendors_mapping`, {
        headers: headers,
      })
      .then((response: AxiosResponse) => {
        if (response.status === 200) {
          _successCallBack(response.data);
        }
      })
      .catch((error: AxiosError) => {
        console.log('Error caught:', error);
        if (error.response?.status === 400) {
          _errorCallBack(error.response.data);
        }
        else if  (error.response?.status === 401){
          localStorage.clear();
        }
        else{
          toast.error("Server Error");
        }
      });
  };
  export const getUserName = (
  phone_number:any,
  _successCallBack: (response: any) => void,
  _errorCallBack: (errMessage: any) => void,
) => {
  const userDetailsFromStorage = JSON.parse(localStorage.getItem("userdetails") || "null");
  const headers = {
    Authorization: `Bearer ${userDetailsFromStorage.token}`
  };
  axios
    .get(`${global.api_url}/api/users/?device_id=&user_phone=${phone_number}&country_code=91`, {
      headers: headers,
    })
    .then((response: AxiosResponse) => {
      if (response.status === 200) {
        _successCallBack(response.data);
      }
      else if(response.status === 201) { 
        _successCallBack(response.data);
      }
    })
    .catch((error: AxiosError) => {
      if (error.response?.status === 400) {
        _errorCallBack(error.response.data);
      }
      else if  (error.response?.status === 401){
        localStorage.clear();
      }
      else if( error.response?.status === 404)
        {
          _errorCallBack(error.response.data);
        }
      else{
        toast.error("Server Error");
      }
    });
};

export const addWarehouseUserMapping = (
  userId: any,
  warehouseId: any,
  successCallBack: (message: any) => void,
  errorCallBack: (errorMessage: any) => void
) => {
  const userDetailsFromStorage = JSON.parse(localStorage.getItem("userdetails") || "null");
  const headers = {
    Authorization: `Bearer ${userDetailsFromStorage.token}`,
  };
  const payload = {
    users_id:userId,
    warehouses_id:warehouseId,
  };
  axios.post(
    `${global.api_url}/api/user_warehouses`,
    payload,
    { headers }
  )
  .then((response: AxiosResponse) => {
    if (response.status === 201) {
      successCallBack(response);
    } 
    else if (response.status === 200) {
      successCallBack(response);
    } 
  })
  .catch((error: AxiosError) => {
    if (error.response) {
      if (error.response.status === 400) {
        errorCallBack(error?.response?.data);
      } else if (error.response.status === 404){
        errorCallBack(error?.response?.data)
      }
      else if( error.response?.status === 409)
        {
          errorCallBack(error?.response?.data);
        }
      else if (error.response.status === 401) {
        localStorage.clear();
        toast.error("Login Expired.");
      }
    } 
    else {
      toast.error("Server Error");
    }
  });
};
export const addWarehouseCompanyMapping = (
    companiesId: any,
    warehouseId: any,
    successCallBack: (message: string) => void,
    errorCallBack: (errorMessage: string) => void
  ) => {
    const userDetailsFromStorage = JSON.parse(localStorage.getItem("userdetails") || "null");
    const payload = {
      companies_id:companiesId,
      warehouses_id:warehouseId,
    };
    const headers = {
      Authorization: `Bearer ${userDetailsFromStorage.token}`,
    };
    axios.post(
      `${global.api_url}/api/warehouses_companies`,
      payload,
      { headers }
    )
    .then((response: AxiosResponse) => {
      if (response.status === 201) {
        successCallBack(response.data.message);
      } 
      else if (response.status === 200) {
        successCallBack(response.data.message);
      }
    })
    .catch((error: any) => {
      if (error.response) {
        if (error.response.status === 400) {
          errorCallBack(error.response.data);
        } else if (error.response.status === 401) {
          localStorage.clear();
          toast.error("Login Expired.");
        }
      } 
      else if( error.response?.status === 404)
        {
          errorCallBack(error?.response?.data);
        }
      else {
        toast.error("Server Error");
      }
    });
  };
  export const addClientVendorWarehouseMapping = (warehouses_id:any,clients_vendors_id:any,
    _successCallBack: (response: any) => void,
    _errorCallBack: (errMessage: any) => void,
    ) => {
      const userDetailsFromStorage = JSON.parse(localStorage.getItem("userdetails") || "null");
      const headers = {
        Authorization: `Bearer ${userDetailsFromStorage.token}`, 
      };
      const payload = {
        warehouses_id,
        clients_vendors_id
      };
    axios
      .post(`${global.api_url}/api/clients_vendors_warehouses`, payload, { headers })
      
      .then((response: AxiosResponse) => {
        if (response.status === 200 || response.status === 201) {
          _successCallBack(response.data);
        } else {
          _errorCallBack("Unexpected status code: " + response.status);
        }
      })
      .catch((error: AxiosError) => {
          console.log('Error caught:', error);
          if (error.response?.status === 400) {
            _errorCallBack(error.response.data);
          } else if (error.response?.status === 404) {
              console.log(error.response.data);
            _errorCallBack(error.response.data);
          }else if (error.response?.status === 401) {
            localStorage.clear();
          } 
        });
  };